// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'chat';

export const Component = () => (
  <path d='M23.046 1.5H1.954a1.86 1.86 0 0 0-1.032.42C.641 2.2.5 2.526.5 2.945v15.288c0 .42.14.746.422 1.025.281.28.61.42 1.032.42h12.14c.14 0 .233.046.28.093l4.735 3.496c.234.14.422.233.61.233a.821.821 0 0 0 .656-.326.918.918 0 0 0 .281-.653V19.68h2.39c.423 0 .75-.14 1.032-.42.281-.28.422-.606.422-1.026V2.946c0-.42-.14-.746-.422-1.026a1.872 1.872 0 0 0-1.032-.42Zm.516 1.445v15.287c0 .326-.188.466-.516.466h-2.671a.603.603 0 0 0-.469.186.665.665 0 0 0-.187.466v3.17l-4.735-3.542c-.234-.187-.515-.28-.89-.28H1.953c-.328 0-.516-.14-.516-.466V2.945c0-.327.188-.466.516-.466h21.092c.328 0 .516.14.516.466Z' />
);

export const viewBox = '0 0 25 25';
